import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle, Collapse, Container, Paper } from '@mui/material';
import { getMetricWidgetImage } from '../../data/aws/cloudwatch/api/getMetricWidget';
const debug = process.env.REACT_APP_DEBUG && false;
const MetricWidget = ({ resource, metricName, metricState, selectedDimensionMapList, start, end }) => {
    debug && console.log('selectedDimensionMapList', selectedDimensionMapList);
    const [widgetImageUrl, setWidgetImageUrl] = useState(undefined);
    const [isUserAuthorised, setIsUserAuthorised] = useState(true);
    const [errorMessage, setErrorMessage] = useState(undefined);
    useEffect(() => {
        const fetchImage = async () => {
            try {
                const metricWidgetResult = await getMetricWidgetImage({ resource, metricName, metricState, selectedDimensionMapList, start, end });
                const metricImageBlob = new Blob([metricWidgetResult], { type: 'image/png' });
                const blobUrl = URL.createObjectURL(metricImageBlob);
                debug && console.log('blobUrl', blobUrl);
                setWidgetImageUrl(blobUrl);
            }
            catch (error) {
                if (error instanceof Error && error.name === 'AccessDenied') {
                    setIsUserAuthorised(false);
                    setErrorMessage(error.message);
                }
                debug && console.error('Error fetching metric widget image:', error);
            }
        };
        fetchImage();
    }, [resource, metricName, metricState, selectedDimensionMapList, start, end]);
    return (_jsx("div", { children: _jsxs(Container, { fixed: true, children: [_jsx(Collapse, { in: !isUserAuthorised, children: _jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: "Error" }), errorMessage] }) }), isUserAuthorised && (_jsx(Paper, { elevation: 3, children: _jsx("img", { src: widgetImageUrl, style: { width: '100%' } }) }))] }) }));
};
export default MetricWidget;
